import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import CalendarGrid, { STATUS_STYLE } from '../components/CalendarGrid';
import Modal from '../components/Modal';
import { ui } from '../ui';

export default function InterviewCalendar() {
  const navigate = useNavigate();
  const [curators, setCurators] = useState([]);
  const [curatorId, setCuratorId] = useState('');
  const [slots, setSlots] = useState([]);
  const [weekOffset, setWeekOffset] = useState(0);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/curators`, { headers: authHeaders() }).then(r => {
      setCurators(r.data);
      if (r.data.length > 0) setCuratorId(String(r.data[0].id));
    });
  }, []);

  const fetchSlots = useCallback(() => {
    if (!curatorId) return;
    axios.get(`${API}/admin/slots`, { headers: authHeaders(), params: { curator_id: curatorId } })
      .then(r => setSlots(r.data));
  }, [curatorId]);
  useEffect(() => { fetchSlots(); }, [fetchSlots]);

  return (
    <Layout>
      <h1 style={ui.title}>Календарь собеседований</h1>
      <p style={{ color: '#9aa3bd', fontSize: 14, marginTop: -8, marginBottom: 20 }}>
        Только просмотр — открывать и отменять слоты может сам куратор в своём кабинете.
      </p>

      <div style={ui.row}>
        <select style={ui.input} value={curatorId} onChange={e => { setCuratorId(e.target.value); setSelected(null); }}>
          {curators.map(c => (
            <option key={c.id} value={c.id}>{c.first_name} {c.last_name || ''}</option>
          ))}
        </select>
      </div>

      {curatorId && (
        <CalendarGrid slots={slots} weekOffset={weekOffset} onWeekChange={setWeekOffset} onSlotClick={setSelected} />
      )}

      {selected && (
        <Modal onClose={() => setSelected(null)}>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>
            {new Date(selected.start_at).toLocaleString('ru', { weekday: 'long', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
            {' · '}{STATUS_STYLE[selected.status]?.label || selected.status}
          </div>
          {selected.user_name && <div style={{ fontSize: 14, marginBottom: 12 }}>Клиент: {selected.user_name} ({selected.user_phone})</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            {selected.user_id && (
              <button style={ui.btnSecondary} onClick={() => navigate(`/applications?open=${selected.user_id}`)}>Перейти в анкету →</button>
            )}
            <button style={ui.btnSecondary} onClick={() => setSelected(null)}>Закрыть</button>
          </div>
        </Modal>
      )}
    </Layout>
  );
}
